const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

export async function getMe() {
  const r = await fetch(`${API}/auth/me`, { credentials: "include" });
  if (!r.ok) throw new Error(String(r.status));
  return r.json();
}

export async function logout() {
  await fetch(`${API}/auth/logout`, { method: "POST", credentials: "include" });
}

export async function getPortfolio() {
  const r = await fetch(`${API}/portfolio`, { credentials: "include" });
  if (!r.ok) throw new Error("Failed to load portfolio");
  return r.json();
}

export async function createPortfolioItem(payload) {
  const r = await fetch(`${API}/portfolio`, {
    method: "POST",
    credentials: "include",
    headers: { "Content-Type": "application/json" },
    body: JSON.stringify(payload),
  });
  if (!r.ok) {
    const e = await r.json().catch(() => ({}));
    throw new Error(e.detail || "Failed to create item");
  }
  return r.json();
}

export async function deletePortfolioItem(id) {
  const r = await fetch(`${API}/portfolio/${id}`, {
    method: "DELETE",
    credentials: "include",
  });
  if (!r.ok) throw new Error("Failed to delete item");
  return r.json();
}

export async function reorderPortfolio(ids) {
  const r = await fetch(`${API}/portfolio/reorder`, {
    method: "POST",
    credentials: "include",
    headers: { "Content-Type": "application/json" },
    body: JSON.stringify({ ids }),
  });
  if (!r.ok) throw new Error("Failed to reorder");
  return r.json();
}

// Chunked upload → bypasses proxy body limits for large videos.
export async function uploadFile(file, onProgress) {
  const CHUNK = 3 * 1024 * 1024;
  const uploadId = `up${Date.now()}${Math.random().toString(36).slice(2, 8)}`;
  const total = Math.max(1, Math.ceil(file.size / CHUNK));
  let result;
  for (let i = 0; i < total; i++) {
    const slice = file.slice(i * CHUNK, (i + 1) * CHUNK);
    const fd = new FormData();
    fd.append("upload_id", uploadId);
    fd.append("chunk_index", String(i));
    fd.append("total_chunks", String(total));
    fd.append("filename", file.name);
    fd.append("chunk", slice, "chunk");
    const r = await fetch(`${API}/admin/upload`, {
      method: "POST",
      credentials: "include",
      body: fd,
    });
    if (!r.ok) {
      const e = await r.json().catch(() => ({}));
      throw new Error(e.detail || "Upload failed");
    }
    result = await r.json();
    onProgress?.(Math.round(((i + 1) / total) * 100));
  }
  return result; // { filename, url, type }
}

export function startGoogleLogin() {
  // REMINDER: DO NOT HARDCODE THE URL, OR ADD ANY FALLBACKS OR REDIRECT URLS, THIS BREAKS THE AUTH
  const redirectUrl = window.location.origin + "/admin";
  window.location.href = `https://auth.emergentagent.com/?redirect=${encodeURIComponent(redirectUrl)}`;
}

export async function exchangeSession(sessionId) {
  const r = await fetch(`${API}/auth/session`, {
    method: "POST",
    credentials: "include",
    headers: { "X-Session-ID": sessionId },
  });
  if (!r.ok) throw new Error("Session exchange failed");
  return r.json();
}
